import React, { useEffect, useState, useMemo } from "react";
import withRouter from "components/Common/withRouter";
import TableContainer from "components/Common/TableContainer";
import {
  Card, CardBody, Col, Container, Row, Spinner, Button,
  Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import axios from "axios";
import toastr from "toastr";
import "toastr/build/toastr.min.css";

const API_BASE = "https://maasradarapi.stechomeyazilim.info";

const PagesList = () => {
  document.title = "Sayfalar | Maaş Radar Admin Paneli";

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [processing, setProcessing] = useState({});

  const [editModal, setEditModal] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [editTitle, setEditTitle] = useState("");
  const [editContent, setEditContent] = useState("");

  function getAuthHeaders() {
    const token = localStorage.getItem("token");
    return { "Authorization": `Bearer ${token}`, "Content-Type": "application/json" };
  }

  const fetchItems = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API_BASE}/Pages`, { headers: getAuthHeaders() });
      setItems(res.data.value || []);
    } catch (error) {
      console.error("Veriler alınamadı", error);
      setItems([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchItems(); }, []);

  const showToast = (success, message) => {
    toastr.options = { positionClass: "toast-top-right", timeOut: 5000, closeButton: true, progressBar: true };
    if (success) toastr.success(message, "Başarılı");
    else toastr.error(message, "Hata");
  };

  const openEdit = (item) => {
    setEditItem(item);
    setEditTitle(item.Title || "");
    setEditContent(item.Content || "");
    setEditModal(true);
  };

  const handleSave = async () => {
    if (!editItem) return;
    setProcessing(p => ({ ...p, [editItem.Id + "save"]: true }));
    try {
      await axios.patch(`${API_BASE}/Pages(${editItem.Id})`, { Title: editTitle, Content: editContent }, { headers: getAuthHeaders() });
      showToast(true, "Sayfa güncellendi.");
      setEditModal(false);
      fetchItems();
    } catch (err) {
      console.error(err);
      showToast(false, "Güncelleme sırasında hata oluştu.");
    } finally {
      setProcessing(p => ({ ...p, [editItem.Id + "save"]: false }));
    }
  };

  const columns = useMemo(() => [
    { Header: "ID", accessor: "Id", width: "80px" },
    { Header: "Slug", accessor: "Slug" },
    { Header: "Başlık", accessor: "Title" },
    {
      Header: "İşlemler", accessor: "actions", disableSortBy: true,
      Cell: ({ row }) => (
        <div className="d-flex gap-2">
          <Button size="sm" color="primary" onClick={() => openEdit(row.original)}>Düzenle</Button>
        </div>
      )
    }
  ], []);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Sayfalar" breadcrumbItem="Liste" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  {loading ? (
                    <div className="text-center py-5"><Spinner color="primary" /></div>
                  ) : (
                    <TableContainer columns={columns} data={items} isGlobalFilter={true} isAddOptions={false} customPageSize={10} className="custom-header-css" />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <Modal isOpen={editModal} toggle={() => setEditModal(false)} size="lg">
        <ModalHeader toggle={() => setEditModal(false)}>Sayfa Düzenle</ModalHeader>
        <ModalBody>
          {editItem && (
            <Form>
              <FormGroup>
                <Label>Slug</Label>
                <Input type="text" value={editItem.Slug} disabled />
              </FormGroup>
              <FormGroup>
                <Label>Başlık</Label>
                <Input type="text" value={editTitle} onChange={(e) => setEditTitle(e.target.value)} />
              </FormGroup>
              <FormGroup>
                <Label>İçerik</Label>
                <Input type="textarea" rows={8} value={editContent} onChange={(e) => setEditContent(e.target.value)} />
              </FormGroup>
              <Button color="primary" disabled={processing[editItem.Id + "save"]} onClick={handleSave}>
                {processing[editItem.Id + "save"] ? <Spinner size="sm" /> : "Kaydet"}
              </Button>
            </Form>
          )}
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default withRouter(PagesList);
